import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class StoreService {
    selectedTab: string;

    constructor(private http: HttpClient) { }
    getUrl(uri: any): any {
        return this.http.get(uri)
        //  .timeout(30000, new Error('delay exceeded'));
    }
    postUrl(uri: any, data: any): any {
        return this.http.post(uri, data)
        //  .timeout(30000, new Error('delay exceeded'));
    }
    setTabName(tab) {
        this.selectedTab = tab;
    }
    getTabName() {
        return this.selectedTab;
    }

    addStoreType(data: any): Observable<any> {
        return this.postUrl(`${environment.apiUrl}` + '/StoreTypeApi.php', data).pipe(map(res => res));
    }
    addStore(data: any): Observable<any> {
        return this.postUrl(`${environment.apiUrl}` + '/StoreMasterApi.php', data).pipe(map(res => res));
    }
    getAllStore(payload: any) {
        return this.postUrl(`${environment.apiUrl}` + '/StoreMasterApi.php', payload).pipe(map(res => res));
    }
    getBusinessUnit(): Observable<any> {
        return this.getUrl(`${environment.apiUrl}` + '/GetBusinessUnitCodeApi.php').pipe(map(res => res))
    }
    getAllStoreTypes(payload: any) {
        return this.postUrl(`${environment.apiUrl}` + '/StoreTypeApi.php', payload).pipe(map(res => res));
    }
    getProcurementReport(data: any): Observable<any> {
        return this.postUrl(`${environment.invapiUrl}` + '/InventoryControlManageApi.php', data).pipe(map(res => res));
    }
    trialbalance(data: any): Observable<any> {
        return this.postUrl(`${environment.accountingUrl}` + '/AccountsTrialBalanceApi.php', data).pipe(map(res => res));
    }
    getDetailedStockMovement(data: any): Observable<any> {
        return this.postUrl(`${environment.invapiUrl}` + '/InvSubStoreStockReport.php', data).pipe(map(res => res));
    }
    getAllSubStore(payload: any) {
        return this.postUrl(`${environment.apiUrl}` + '/InvSubStoreUtilization.php', payload).pipe(map(res => res));
    }
}
